// extracted by mini-css-extract-plugin
module.exports = {"ContactList":"ContactList_ContactList__1Mw3C","ContactList__Title":"ContactList_ContactList__Title__1HfI6","ContactList__Item":"ContactList_ContactList__Item__3yCS4"};